<template>
	<div class="parameter-container">
		<div
			class="parameter-lists"
			v-for="(item, index) in lists"
			:key="index"
		>
			<div class="parameter-list">
				<div class="title">{{ item.name }}</div>
				<div class="row">
					<div class="item mr-16">
						<div class="label">放电深度：</div>
						<div class="value">{{ item.dod }}%</div>
					</div>
					<div class="item mr-16">
						<div class="label">综合效率：</div>
						<div class="value">{{ item.efficiency }}%</div>
					</div>
					<div class="item mr-16">
						<div class="label">变压器容量：</div>
						<div class="value">{{ item.demandLimit }}kVA</div>
					</div>
				</div>
				<div class="row">
					<div class="item">
						<div class="label">尖峰平谷深谷电价（元/kWh）：</div>
						<span
							style="display: inline-block"
							class="value"
							v-for="(value, index) of item.electricPrice"
							:key="value + index"
						>
							{{ value }}
							<span
								class="split"
								v-show="index !== item.electricPrice.length - 1"
							>
								/
							</span>
						</span>
					</div>
				</div>
				<a-row class="config-box" :gutter="12">
					<a-col :span="24">
						<echarts-component
							style="height: 194px"
							:options="item.options"
						></echarts-component>
					</a-col>
				</a-row>
			</div>
		</div>
	</div>
</template>

<script setup>
import {onMounted, ref, defineProps, watch} from "vue";

// components
import EchartsComponent from "@/components/EchartsComponent.vue";

import {handleTacticsData} from "@/plugins";

const props = defineProps({
	strategyCurveListData: {
		type: Array,
		default: () => {
			return [];
		},
	},
});

const lists = ref([]);

// 处理数据
const handleData = (datas = []) => {
	const arr = [];
	datas.map(row => {
		const {
			dod,
			efficiency,
			demandLimit,
			tfmCapacity,
			sharp,
			peak,
			flat,
			valley,
			ravine,
			name,
			curve,
			timeRanges,
		} = row;

		let obj = {
			dod,
			efficiency,
			demandLimit,
			tfmCapacity,
			electricPrice: [
				sharp ? sharp : "-",
				peak ? peak : "-",
				flat ? flat : "-",
				valley ? valley : "-",
				ravine ? ravine : "-",
			],
			name,
			options: {},
		};

		const Options = handleTacticsData(curve, timeRanges);
		Options.yAxis["axisLabel"] = {
			formatter: function (value) {
				if (value === 0) {
					return "静置";
				} else if (value === 1) {
					return "充电";
				} else if (value === -1) {
					return "放电";
				} else {
					return "-";
				}
			},
		};
		delete Options.legend;
		Options.tooltip = {
			trigger: "axis",
			formatter: params => {
				let str = `-`;
				if (params.length > 0) {
					const value = params[0].data;
					const time = params[0].axisValue;

					if (value === 0) {
						str = "静置";
					} else if (value === 1) {
						str = "充电";
					} else if (value === -1) {
						str = "放电";
					} else {
						str = "-";
					}

					str = `${time} <span style="color: #0BBA74">${str}</span>`;
				}
				return `${str}`;
			},
		};
		Options.color = ["#0BBA74"];
		Options.series[0].step = "end";
		obj.options = Options;
		arr.push(obj);
	});

	lists.value = arr;
};

watch(
	() => props.strategyCurveListData,
	newVal => {
		if (newVal && newVal.length > 0) {
			handleData(newVal);
		}
	},
	{immediate: true, deep: true}
);
</script>

<style lang="less" scoped>
.parameter-container {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 24px;
}
.parameter-lists {
	.title {
		font-family: PingFangSC-Medium;
		font-family: PingFangSC-Medium;
		font-weight: 500;
		font-size: 18px;
		color: rgba(0, 0, 0, 0.85);
		letter-spacing: 0;
		height: 26px;
		line-height: 26px;
		text-align: center;
		margin: 16px 0 12px 0;
	}
	.parameter-list {
		background: #e9eff666;
		border: 1px solid #a2abbb66;
		border-radius: 4px;
		margin-bottom: 32px;
		padding: 0 16px 16px 16px;

		.row {
			padding-bottom: 12px;
			display: flex;
			align-items: center;
			.item {
				.label {
					height: 24px;
					line-height: 22px;
					font-family: PingFangSC-Regular;
					font-weight: 400;
					font-size: 14px;
					color: rgba(0, 0, 0, 0.65);
					letter-spacing: 0;
				}

				.value {
					height: 24px;
					font-family: PingFangSC-Medium;
					font-weight: 500;
					font-size: 16px;
					color: rgba(0, 0, 0, 0.85);
					letter-spacing: 0;
					line-height: 24px;
				}
				.split {
					color: rgba(0, 0, 0, 0.45);
				}
			}

			.mr-16 {
				margin-right: 56px;
			}
		}

		.config-box {
			margin-top: 12px;

			.config-box-title {
				width: 100%;
				height: 24px;
				opacity: 0.85;
				font-family: PingFangSC-Medium;
				font-weight: 600;
				font-size: 16px;
				color: #000000;
				letter-spacing: 0;
				line-height: 24px;
				text-align: center;
				margin-bottom: 8px;
			}
		}
	}
}
</style>
